/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;


/**
 * Load
 */
$(window).on("load", function() {

    
    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

        setTimeout(function() {
            pageEnter(() => {
                $(document).trigger("loadermanager-page_entered");
            });
        }, 200);

    });


    /**
     * Configurazione globale componenti uikit
     */
    (function() {
        // container false per modal, evita duplicazione elemento in seguito a caricamenti asincroni (barba.js)
        UIkit.mixin({
            data: {
                container: false,
            }
        }, 'modal');
    })();


    /**
     * Update necessari dopo caricamenti livewire
    */
    Livewire.hook('message.processed', function () {

        // update locomotive scroll per adeguamento contenuti
        if(window.locomotive) {
            window.locomotive.update();
        }
        
        // scroll a eventuale messaggio di errore form
        scrollToFormError();

    });


    // scroll a eventuale messaggio di errore form, al caricamento!
    scrollToFormError();
        
    
    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");


});


/**
 * Scroll al primo messaggio di errore di un form
 */
function scrollToFormError()
{
    // se ho dei messaggi di validazione di un form, scrollo al primo messaggio
    if (!$('form .field__error').length) {
        return;
    }

    if(window.locomotive) {
        window.locomotive.update();
        window.locomotive.scrollTo($('form .field__error').eq(0)[0], {
            offset: -200 // valore empirico per considerare altezza header sticky
        });
    }
}



/**
 * Funzione di entrata pagina
 */
function pageEnter(callback)
{

    gsap.to("#page_loader", {
        y: 0,
        opacity:0,
        duration: 1,
        onComplete : function() {
            
            // porto sotto per poter interagire con pagina
            $("#page_loader").css({
                zIndex: -1
            });

            if(callback && typeof(callback) == 'function') {
                callback();
            }
        }
    });

}
